import { AnalysisState } from '../core';
import { SubsettingNotebookCell } from './cells/SubsettingNotebookCell';
import { TextNotebookCell } from './cells/TextNotebookCell';
import { VisualizationNotebookCell } from './cells/VisualizationNotebookCell';
import { ComputeNotebookCell } from './cells/ComputeNotebookCell';
import { NotebookCellDescriptor } from './Types';
import { WdkParamNotebookCell } from './cells/WdkParamNotebookCell';
import { SharedComputeInputsNotebookCell } from './cells/SharedComputeInputsNotebookCell';
import { WdkState } from './EdaNotebookAnalysis';
import { JobStatus } from '../core/components/computations/ComputeJobStatusHook';

export interface NotebookCellProps<T extends NotebookCellDescriptor> {
  analysisState: AnalysisState;
  cell: T;
  isDisabled?: boolean; // Indicates if the cell is disabled (e.g., before a computation is complete).
  expandedPanelState?: 'closed' | 'open'; // Indicates if the ExpandabelPanel is expanded in the UI.
  wdkState?: WdkState;
  projectId?: string; // Project ID, ex: PlasmoDB, MicrobiomeDB, etc.
  computeJobStatus?: JobStatus; // Optional status of the compute job, useful for displaying progress or errors.
  stepNumber?: number; // Auto-computed step number for NumberedHeader display.
  stepNumbers?: Map<string, number>; // Map of cell IDs to their step numbers (for forwarding to nested cells).
}

/**
 * Top-level component that delegates to imeplementations of NotebookCell variants.
 */
export function NotebookCell(props: NotebookCellProps<NotebookCellDescriptor>) {
  const { cell } = props;
  switch (cell.type) {
    case 'subset':
      return <SubsettingNotebookCell {...props} cell={cell} />;
    case 'text':
      return <TextNotebookCell {...props} cell={cell} />;
    case 'visualization':
      return <VisualizationNotebookCell {...props} cell={cell} />;
    case 'compute':
      return <ComputeNotebookCell {...props} cell={cell} />;
    case 'wdkparam':
      return <WdkParamNotebookCell {...props} cell={cell} />;
    case 'sharedcomputeinputs':
      return <SharedComputeInputsNotebookCell {...props} cell={cell} />;
    default:
      return null;
  }
}
